<template>
  <Panel title="组件配置">
    <el-radio-group v-model="value.isHsm" @input="handleDeviceNameChange">
      <el-radio label="UKEY">USBKey</el-radio>
      <el-radio label="HSM">HSM</el-radio>
    </el-radio-group>
    <el-form
      ref="USBKeyForm"
      label-position="top"
      :rules="USBKeyRules"
      :model="value"
      v-show="value.isHsm === 'UKEY'"
    >
      <el-row>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="IC卡/USBKey密码" prop="ukeyPassword">
            <el-input v-model="value.ukeyPassword"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="算法类型" prop="encryption">
            <el-select v-model="value.encryption" placeholder="请选择">
              <el-option label="rsa" value="rsa"> </el-option>
              <el-option label="sm" value="sm"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      ref="HSMForm"
      label-position="top"
      :rules="HSMRules"
      :model="value"
      v-show="value.isHsm === 'HSM'"
    >
       <el-row>

        <el-col :span="12">
          <el-form-item label="用户证书部署路径" prop="userCertDir">
            <el-input v-model="value.userCertDir"></el-input>
          </el-form-item>
        </el-col>
         <el-col :span="12">
           <el-form-item label="算法类型" prop="encryption">
             <el-select v-model="value.encryption" placeholder="请选择">
               <el-option label="rsa" value="rsa"> </el-option>
               <el-option label="sm" value="sm"> </el-option>
             </el-select>
           </el-form-item>
         </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="加密机配置文件部署路径" prop="userConfig">
            <el-input v-model="value.userConfig"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="加密机使用密钥位置" prop="signKeyIndex">
            <el-input v-model="value.signKeyIndex"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>

        <el-col :span="12">
          <el-form-item label="加密机型号" prop="hsmType">
            <el-input v-model="value.hsmType"></el-input>
          </el-form-item>
        </el-col>



      </el-row>
    </el-form>
  </Panel>
</template>
<script>
var validatePassword = (rule, value, callback) => {
  var strRegex = /^(\d{8})$/;
  if (value && value.trim()) {
    if (!strRegex.test(value)) {
      callback(new Error('请输入8位数字密码'));
    } else {
      callback();
    }
  } else {
    callback(new Error('密码不能为空'));
    callback();
  }
};
import CommonApi from '@/api/Common';
export default {
  props: {
    // ukeyPassword;
    // deviceName = "USBKey";
    // hostId;
    value: { type: Object, default: () => {} },
    uuid: { type: String, default: '' },
  },
  data: () => ({
    data: '',
    mouldData: '',
    loading: false,
    USBKeyRules: {
      ukeyPassword: [
        {
          validator: validatePassword,
          trigger: 'blur',
        },
      ],
      encryption: [
        {
          message: '算法类型不能为空',
          trigger: 'blur',
          required: true,
        },
      ],
    },
    HSMRules: {
      userConfig: [
        {
          message: '加密机配置文件部署路径不能为空',
          trigger: 'blur',
          required: true,
        },
      ],
      signKeyIndex: [
        {
          message: '加密机使用密钥位置不能为空',
          trigger: 'blur',
          required: true,
        },
      ],
      encryption: [
        {
          message: '算法类型不能为空',
          trigger: 'blur',
          required: true,
        },
      ],
    },
    radio: 0,
  }),
  created() {
    // this.$set(this.value, 'deviceName', this.value['deviceName']);
    this.$set(this.value, 'encryption', this.value['encryption']);
    this.$set(this.value, 'ukeyPassword', this.value['ukeyPassword']);
    this.$set(this.value, 'userConfig', this.value['userConfig']);
    this.$set(this.value, 'userCertDir', this.value['userCertDir']);
    this.$set(this.value, 'signKeyIndex', this.value['signKeyIndex']);
    this.$set(this.value, 'hsmType', this.value['hsmType']);
    this.$set(this.value, 'isHsm', this.value['isHsm']);
    if (!this.value.isHsm) {
      this.value.isHsm = 'UKEY';
    }
  },
  watch: {},
  mounted() {},
  methods: {
    validate() {
      if (this.value.isHsm === 'UKEY') {
        return this.$refs.USBKeyForm.validate();
      } else {
        return this.$refs.HSMForm.validate();
      }
    },
    init() {},
    fmt() {
      try {
        let json = JSON.parse(this.data);
        this.data = JSON.stringify(json, '  ', 4);
      } catch (e) {
        this.$message.warning('JSON格式非法');
        this.$refs.input.focus();
      }
    },
    async template() {
      if (!this.uuid) {
        return;
      }
      try {
        this.loading = true;
        let respData = await CommonApi.getJsonMould(this.uuid);
        this.mouldData = respData.jsonMould || '{}';
      } finally {
        this.loading = false;
      }
    },
    // 设备名称切换触发
    handleDeviceNameChange() {
      this.value.encryption = '';
      this.value.userConfig = '';
      this.value.signKeyIndex = '';
      this.value.ukeyPassword = '';
      this.value.userCertDir = '';
      this.value.hsmType = '';
      this.$refs.HSMForm.clearValidate();
      this.$refs.USBKeyForm.clearValidate();
    },
  },
};
</script>

<style scoped></style>
